import React from 'react';
import { Box, Container, Typography, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { brandLogo } from '@/shared/libs/brand';

const HomePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        minHeight: '100dvh',
        textAlign: 'center',
        px: 3,
      }}
    >
      <Container maxWidth="md">
        <Box
          component="img"
          src={brandLogo.src}
          alt={brandLogo.alt}
          sx={{
            width: 'min(100%, 560px)',
            maxHeight: brandLogo.heroMaxHeight,
            objectFit: 'contain',
            // Preflight sets `display: block` on images. A block element with a width
            // ignores the ancestor's `textAlign: center`, which is what used to centre
            // this, so the centring has to be explicit now.
            mx: 'auto',
            mb: 0,
          }}
        />
        {/* 
        <Box
          component="img"
          src="/currikulo logo.png"
          alt="currikulo"
          sx={{
            width: 'min(100%, 560px)',
            maxHeight: { xs: 140, sm: 180, md: 220 },
            objectFit: 'contain',
            mb: 0,
          }}
        />
        <Box
          component="img"
          src="/curricula logo.png"
          alt="curricula"
          sx={{
            width: 'min(100%, 560px)',
            maxHeight: { xs: 140, sm: 180, md: 220 },
            objectFit: 'contain',
            mb: 0,
          }}
        />
        <Box
          component="img"
          src="/Commonly Logo.png"
          alt="Commonly"
          sx={{
            width: 'min(100%, 560px)',
            maxHeight: { xs: 140, sm: 180, md: 220 },
            objectFit: 'contain',
            mb: 0,
          }}
        />
        {1==2 &&(<Box
          component="img"
          src="/CoPlan Logo.png"
          alt="CoPlan"
          sx={{
            width: 'min(100%, 560px)',
            maxHeight: { xs: 60, sm: 80, md: 100 },
            objectFit: 'contain',
            mb: 0,
          }}
        />)}
          {1==2 &&(<Box
          component="img"
          src="/Radicle Logo.png"
          alt="Radicle"
          sx={{
            width: 'min(100%, 560px)',
            maxHeight: { xs: 160, sm: 200, md: 240 },
            objectFit: 'contain',
            mb: 0,
          }}
        />)} */}
        <Typography variant="h3" component="h1" sx={{ mb: 1.5, mt: 1, fontWeight: 600 }}>
          Create, organize, discover, and collaborate
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          A free workspace to support high quality teaching and learning.
        </Typography>
        <Stack direction="row" spacing={2} justifyContent="center" flexWrap="wrap" useFlexGap>
          <Button variant="contained" size="large" onClick={() => navigate('/signup')}>
            Create a Free Account
          </Button>
          <Button variant="outlined" size="large" onClick={() => navigate('/login')}>
            Sign In
          </Button>
        </Stack>
      </Container>
    </Box>
  );
};

export default HomePage;
